import React from 'react'
import '../Styles/GetInvolvedPage3.scss';

function GetInvolvedPage3() {
   return(
      <div className="getInvolvedPage3Content">
         <div className="getInvolvedPage3Container">
            <div className="getInvolvedPage3Description">
              "My summer at Camp Connect truely changed my life. The people that God allows you to influence and the growing that you do 
              were so incredibly helpful in my life. I would highly recommend working the summer at Camp Connect"<br></br><br></br>
              - former summer staff counselor
              
            </div>
         </div>
      </div>
   )
}
export default GetInvolvedPage3;